import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

const BTN_HEIGHT = 26;
const GAP_BOTTOM = 1;
const GAP_RIGHT = 2;


export default /*@__PURE__*/_defineComponent({
  __name: 'QTLiteAddCommentBtn',
  props: {
    enabled: { type: Boolean },
    tableEl: {},
    scrollEl: {},
    topOffset: {},
    minTop: {}
  },
  emits: ["add"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 4 + 18 + 4 по макету, высота нужна до отрисовки, чтобы кнопка сразу встала на место
const rootEl = ref<HTMLElement | null>(null);
const btnTop = ref(0);
const btnRight = ref(GAP_RIGHT);
const hoveredEntityId = ref(0);

const shown = computed(() => props.enabled && hoveredEntityId.value > 0);

// строка, которой мы держим подсветку: пока курсор на кнопке, штатный :hover у строки пропадает
let hoveredRow: HTMLElement | null = null;

function setHoveredRow(tr: HTMLElement | null) {
  if (hoveredRow === tr) return;
  if (hoveredRow) hoveredRow.classList.remove("qtl-row--hover");
  hoveredRow = tr;
  if (hoveredRow) hoveredRow.classList.add("qtl-row--hover");
}

function rowUnderPoint(y: number): HTMLElement | null {
  const table = props.tableEl;
  if (!table) return null;
  const trs = table.querySelectorAll<HTMLElement>("tbody tr.qtl-row");
  for (const tr of trs) {
    const r = tr.getBoundingClientRect();
    if (y >= r.top && y < r.bottom) return tr;
  }
  return null;
}

function clear() {
  setHoveredRow(null);
  hoveredEntityId.value = 0;
}

function place(tr: HTMLElement | null) {
  const root = rootEl.value;
  if (!tr || !root) {
    clear();
    return;
  }

  const entityId = Number(tr.dataset.entityId || 0);
  if (!entityId) {
    clear();
    return;
  }

  const rootRect = root.getBoundingClientRect();
  const rowRect = tr.getBoundingClientRect();
  const scroll = props.scrollEl;
  const limit = scroll ? scroll.getBoundingClientRect() : rootRect;

  // Границы считаем по содержимому скролла (clientWidth/clientHeight), а не по его
  // прямоугольнику: иначе кнопка ложится на полосы прокрутки и перекрывает их.
  const visibleRight = scroll ? limit.left + scroll.clientWidth : rootRect.right;
  const visibleBottom = scroll ? limit.top + scroll.clientHeight : rootRect.bottom;

  // строка ушла за пределы видимой части - кнопку не показываем
  if (rowRect.bottom <= limit.top || rowRect.top >= visibleBottom) {
    clear();
    return;
  }

  const raw = rowRect.bottom - rootRect.top - BTN_HEIGHT - GAP_BOTTOM;
  const min = (props.topOffset ?? 0) + (props.minTop ?? 0);
  const max = visibleBottom - rootRect.top - BTN_HEIGHT - GAP_BOTTOM;
  btnTop.value = Math.max(min, Math.min(raw, max));
  btnRight.value = Math.max(GAP_RIGHT, Math.round(rootRect.right - visibleRight) + GAP_RIGHT);
  hoveredEntityId.value = entityId;
  setHoveredRow(tr);
}

function onHostMouseMove(ev: MouseEvent) {
  if (!props.enabled) {
    clear();
    return;
  }
  place(rowUnderPoint(ev.clientY));
}

function onHostMouseLeave(ev: MouseEvent) {
  // уход курсора на саму кнопку не считаем уходом из таблицы
  const to = ev.relatedTarget as HTMLElement | null;
  if (to && rootEl.value && rootEl.value.contains(to)) return;
  clear();
}

function onScroll() {
  if (!hoveredRow) return;
  place(hoveredRow);
}

function onClick() {
  const id = hoveredEntityId.value;
  if (!id) return;
  clear();
  emit("add", id);
}

let host: HTMLElement | null = null;
let attachedScroll: HTMLElement | null = null;

function attachHost() {
  detachHost();
  host = rootEl.value?.parentElement || null;
  if (!host) return;
  host.addEventListener("mousemove", onHostMouseMove);
  host.addEventListener("mouseleave", onHostMouseLeave);
}

function detachHost() {
  if (!host) return;
  host.removeEventListener("mousemove", onHostMouseMove);
  host.removeEventListener("mouseleave", onHostMouseLeave);
  host = null;
}

function attachScroll(el: HTMLElement | null | undefined) {
  if (attachedScroll === el) return;
  if (attachedScroll) attachedScroll.removeEventListener("scroll", onScroll);
  attachedScroll = el || null;
  attachedScroll?.addEventListener("scroll", onScroll, { passive: true });
}

onMounted(() => {
  attachHost();
  attachScroll(props.scrollEl);
});

watch(() => props.scrollEl, (el) => attachScroll(el));
watch(() => props.enabled, (on) => { if (!on) clear(); });

onBeforeUnmount(() => {
  clear();
  detachHost();
  if (attachedScroll) attachedScroll.removeEventListener("scroll", onScroll);
  attachedScroll = null;
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    class: "qtl-add-comment-layer"
  }, [
    (shown.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "qtl-add-comment",
          style: _normalizeStyle({ top: btnTop.value + 'px', right: btnRight.value + 'px' }),
          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
          onClick: _withModifiers(onClick, ["stop"])
        }, [
          _cache[1] || (_cache[1] = _createStaticVNode("<svg class=\"qtl-add-comment__pencil\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-41b775a2><path d=\"M15.916 4.96744C16.1579 4.72534 16.1062 4.28108 15.8003 3.97521L14.0227 2.19756C13.7167 1.89167 13.2724 1.83978 13.0303 2.0819L11.5684 3.54388L14.4539 6.42944L15.916 4.96744Z\" fill=\"currentColor\" data-v-41b775a2></path><path d=\"M1.82721 16.3264C2.45354 16.1893 4.35117 15.6936 5.01569 15.5191C5.16843 15.4791 5.30784 15.399 5.41938 15.2871L13.3689 7.33816L10.6601 4.62952L2.71052 12.5784C2.59861 12.69 2.51861 12.8294 2.47849 12.9822C2.30396 13.6468 1.80836 15.5448 1.67204 16.1717C1.6624 16.215 1.67561 16.2602 1.70704 16.2915C1.73847 16.323 1.78387 16.3361 1.82721 16.3264Z\" fill=\"currentColor\" data-v-41b775a2></path></svg><svg class=\"qtl-add-comment__plus\" width=\"9\" height=\"9\" viewBox=\"0 0 9 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-41b775a2><path d=\"M0.875 4.375L7.875 4.375\" stroke=\"currentColor\" stroke-width=\"1.6875\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-41b775a2></path><path d=\"M4.375 0.875L4.375 7.875\" stroke=\"currentColor\" stroke-width=\"1.6875\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-41b775a2></path></svg>", 2)),
          _createVNode(_component_q_tooltip, {
            delay: 300,
            anchor: "top middle",
            self: "center middle",
            class: "qtl-add-comment-tooltip"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('add_comment')), 1)
            ]),
            _: 1
          })
        ], 36))
      : _createCommentVNode("", true)
  ], 512))
}
}

})